import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Assignment from '@mui/icons-material/Assignment';
import { CollapseCard, FakeText } from '@totalsoft/rocket-ui';
import FacilityGeneralInfoComponent from './FacilityGeneralInfoComponent';

const FacilityGeneralInfoCard = ({
  facilityHeader,
  onSave,
  onTransferFacilityToERP,
  isSaving,
  isTransfering,
  isDirty,
  validation,
  onPropertyChange,
  loadCurrencies,
  facilityRevolvingTypes,
  facilityFlexibilityRules,
  facilityCreditLineStatuses,
  facilityPurposesForApplication,
  partnerGroups,
  partnerOptions,
  transferToERPPermissions,
  loadPartners,
  loading,
  openLinkedDocument,
  editable
}) => {
  const { t } = useTranslation();

  return (
    <CollapseCard icon={Assignment} title={t('Folder.GeneralData.GeneralInfo.Title')} defaultExpanded>
      {loading ? (
        <FakeText lines={6} />
      ) : (
        <FacilityGeneralInfoComponent
          onSave={onSave}
          onTransferFacilityToERP={onTransferFacilityToERP}
          isSaving={isSaving}
          isTransfering={isTransfering}
          isDirty={isDirty}
          validation={validation}
          facilityRevolvingTypes={facilityRevolvingTypes}
          facilityFlexibilityRules={facilityFlexibilityRules}
          facilityCreditLineStatuses={facilityCreditLineStatuses}
          facilityPurposesForApplication={facilityPurposesForApplication}
          partnerGroups={partnerGroups}
          partnerOptions={partnerOptions}
          transferToERPPermissions={transferToERPPermissions}
          loadCurrencies={loadCurrencies}
          loadPartners={loadPartners}
          facilityHeader={facilityHeader}
          onPropertyChange={onPropertyChange}
          openLinkedDocument={openLinkedDocument}
          editable={editable}
        />
      )}
    </CollapseCard>
  );
};

FacilityGeneralInfoCard.propTypes = {
  facilityHeader: PropTypes.object.isRequired,
  onSave: PropTypes.func.isRequired,
  onTransferFacilityToERP: PropTypes.func.isRequired,
  isSaving: PropTypes.bool.isRequired,
  isTransfering: PropTypes.bool.isRequired,
  isDirty: PropTypes.bool.isRequired,
  validation: PropTypes.object,
  onPropertyChange: PropTypes.func.isRequired,
  loadCurrencies: PropTypes.func.isRequired,
  facilityRevolvingTypes: PropTypes.array.isRequired,
  facilityFlexibilityRules: PropTypes.array.isRequired,
  facilityCreditLineStatuses: PropTypes.array.isRequired,
  facilityPurposesForApplication: PropTypes.array.isRequired,
  partnerGroups: PropTypes.array.isRequired,
  partnerOptions: PropTypes.array.isRequired,
  transferToERPPermissions: PropTypes.object.isRequired,
  loadPartners: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  openLinkedDocument: PropTypes.func,
  editable: PropTypes.string
};

export default FacilityGeneralInfoCard;
